module.exports = __webpack_public_path__ + "img/droplet-half.5a28f6eb.svg";